/** Code samples for the playground's "Get code" and the docs page. */
const pretty = (v: unknown, indent = 2) => JSON.stringify(v, null, indent)

export function curlSnippet(body: unknown, base: string): string {
  return `curl ${base}/v1/decide \\
  -H "Authorization: Bearer $TRODO_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '${pretty(body).replace(/'/g, "'\\''")}'`
}

export function pythonSnippet(body: unknown, base: string): string {
  return `import os, requests

resp = requests.post(
    "${base}/v1/decide",
    headers={"Authorization": f"Bearer {os.environ['TRODO_API_KEY']}"},
    json=${pretty(body, 4).replace(/\btrue\b/g, 'True').replace(/\bfalse\b/g, 'False').replace(/\bnull\b/g, 'None').split('\n').join('\n    ')},
    timeout=120,  # the first call after a quiet spell can take up to a minute
)
resp.raise_for_status()
for name, answer in resp.json()["answers"].items():
    print(name, answer)`
}

export function typescriptSnippet(body: unknown, base: string): string {
  return `const resp = await fetch("${base}/v1/decide", {
  method: "POST",
  headers: {
    Authorization: \`Bearer \${process.env.TRODO_API_KEY}\`,
    "Content-Type": "application/json",
  },
  body: JSON.stringify(${pretty(body).split('\n').join('\n  ')}),
})
if (!resp.ok) throw new Error((await resp.json()).error.message)
const { answers, usage } = await resp.json()
console.log(answers, usage)`
}
